/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]   a[_ngcontent-%COMP%]{text-decoration:none;color:#fff;margin-right:10px;width:15px;height:15px;vertical-align:middle}[_nghost-%COMP%]   .fa-circle[_ngcontent-%COMP%]{font-size:1.1em;top:-7px}[_nghost-%COMP%]   .fa-facebook-f[_ngcontent-%COMP%]{top:-5px;color:#ffb600}"];
export { styles as styles };
